import { render, staticRenderFns } from "./ConsentRow.vue?vue&type=template&id=054d0d19"
import script from "./ConsentRow.vue?vue&type=script&lang=js"
export * from "./ConsentRow.vue?vue&type=script&lang=js"
import style0 from "./ConsentRow.vue?vue&type=style&index=0&id=054d0d19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports